import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const container_resize = { width: '100% !important' };

export const containerSizesTop = {
  padding: '0px 0px',
  margin: '128px 0px 0px',
  [MediaQueries.sm]: {
    padding: '0px 0px',
    margin: '64px 0px 0px',
  },
  [MediaQueries.lg]: {
    margin: '96px 0px 0px',
  },
  [MediaQueries.md]: {
    margin: '96px 0px 0px',
  },

  '.mid_sec': {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 24px',
    [MediaQueries.xl]: {
      marginTop: '-50PX',
    },

    [MediaQueries.lg]: {
      marginTop: '50PX',
      marginBottom: '50px',
    },

    [MediaQueries.md]: {
      padding: '0px 48px',
    },

    [MediaQueries.sm]: {
      display: 'block',
      overflow: 'hidden',
      padding: '0px 0px 0px 24px',
    },

    '.left_sec': {
      display: 'flex',
      position: 'relative',
      marginTop: '270px',
      [MediaQueries.lg]: {
        paddingRight: '20px',
        position: 'unset',
        paddingTop: '56px',
        marginTop: '15px',
      },
      [MediaQueries.md]: {
        paddingRight: '10px',
        position: 'unset',
        marginTop: '15px',
      },
      [MediaQueries.sm]: {
        top: '64px',
        position: 'absolute',
        marginTop: '0px',
      },

      '.img_sec': {
        position: 'absolute',
        top: 'auto',
        right: '0',
        margin: '50px 0px 0px',

        img: {
          width: '304px',
          height: '304px',
          objectFit: 'cover',

          [MediaQueries.lg]: {
            maxWidth: '296px',
            height: '296px',
            width: '296px',
          },
          [MediaQueries.md]: {
            maxWidth: '232px',
            height: '232px',
            width: '232px',
          },
        },

        [MediaQueries.lg]: {
          position: 'absolute',
          top: '276px',
          left: '-400px',
        },
        [MediaQueries.md]: {
          position: 'absolute',
          top: '250px',
          left: '-330px',
        },
        [MediaQueries.sm]: {
          display: 'none',
        },
      },
      '.text_left': {
        marginRight: '72px',

        [MediaQueries.lg]: {
          marginRight: '0px',
          marginLeft: '0px',
        },
        [MediaQueries.md]: {
          marginRight: '0px',
          marginLeft: '20px',
        },
        [MediaQueries.sm]: {
          marginRight: '40px',
          marginLeft: '0px',
        },

        '.contentDescriptionCss': {
          fontSize: '14px',
          fontStyle: 'normal',
          maxWidth: '415px',
          color: '#393939',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '0px',
          textAlign: 'left',
          marginBottom: '32px',
          [MediaQueries.lg]: {
            maxWidth: 'unset',
          },
        },

        '.list_point': {
          li: {
            marginBottom: '24PX',
            display: 'flex',
            maxWidth: '415px',
            '.img_point': {
              marginRight: '16px',
              display: 'flex',

              img: {
                marginTop: '5px',
              },
            },
            '.textpoint': {
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '24px',
              letterSpacing: '0px',
              textAlign: 'left',
            },
          },
        },
      },
      '.contentHeadlineCss': {
        fontSize: '32px',
        lineHeight: '32px',
        letterSpacing: '-0.4px',
        fontWeight: 500,
        maxWidth: '316px',
        marginBottom: '32px',
      },
    },

    '.tab_sec': {
      maxWidth: '280px',
      position: 'relative',
      width: '100%',
      marginRight: '100px',

      [MediaQueries.lg]: {
        maxWidth: '332px',
        marginRight: '100px',
      },
      [MediaQueries.md]: {
        maxWidth: '256px',
        marginRight: '85px',
      },

      [MediaQueries.sm]: {
        maxWidth: '100%',
        marginRight: '0px',
      },

      '.background_imgleft': {
        img: {
          maxWidth: '582px',
          marginLeft: '-50px',
          [MediaQueries.lg]: {
            position: 'relative',
            top: '111px',
          },
          [MediaQueries.sm]: {
            marginBottom: '-140px',
          },
          [MediaQueries.md]: {
            top: '-130px',
            position: 'relative',
            marginLeft: '-80px',
            marginBottom: '-250PX',
          },
        },
      },

      ul: {
        textAlign: 'right',
        position: 'absolute',
        top: '270px',
        right: '0px',
        [MediaQueries.lg]: {
          textAlign: 'right',
          top: '0px',
        },

        [MediaQueries.md]: {
          textAlign: 'right',
          marginRight: '0px',
          top: '0px',
        },
        [MediaQueries.sm]: {
          textAlign: 'right',
          marginRight: '0px',
          overflow: 'auto',
          top: '0px',
          display: 'flex',
          left: '0px',
          background: [
            'rgba(255,255,255,0)',
            'linear-gradient(0deg,rgba(255,255,255,0) 90%, #ffffff 100%)',
            '-webkit-linear-gradient(0deg,rgba(255,255,255,0) 90%, #ffffff 100%)',
            '-moz-linear-gradient(0deg,rgba(255,255,255,0) 90%, #ffffff 100%)',
          ],
        },
      },

      li: {
        lineHeight: '32px',
        button: {
          border: '0',
          background: 'transparent',
          cursor: 'pointer',
          outline: '0px',
          fontSize: '18px !important',
          lineHeight: '32px',
          color: '#393939',
          fontWeight: '500',
          opacity: '0.5',
          whiteSpace: 'nowrap',
          [MediaQueries.sm]: {
            fontSize: '16px',
            lineHeight: '24px',
          },
        },

        'button:hover': { fontWeight: '500', opacity: 'unset' },
        marginBottom: '24px',
        cursor: 'pointer',
        paddingRight: '15px',
      },
    },
    '.tab_sec_result': {
      maxWidth: '800px',
      width: '100%',
      position: 'relative',
      zoom: 1,
      [MediaQueries.sm]: {
        position: 'absolute',
        top: 64,
        width: '90%',
      },
    },
  },
};

export const tabHolder = css({
  '.scroll-shadow': {
    [MediaQueries.sm]: {
      position: 'absolute',
      background: 'yellow',
      width: 40,
      top: 0,
      background:
        'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
      height: 48,
      right: 0,
    },
  },
});

export const CommonCss = css({});

export const tabsHeaderCss = css({});
export const tabsContentCss = css({});

export const itemTabCss = css({});
export const itemTabActiveCss = css({
  borderRight: '#E52500 solid 4px',
  button: {
    fontSize: '22px !important',
    letterSpacing: '-0.004em',
    opacity: 'unset !important',
    [MediaQueries.sm]: {
      fontSize: '16px !important',
      lineHeight: '24px',
    },

    span: {
      [MediaQueries.sm]: {
        borderBottom: '#E52500 solid 4px',
        paddingBottom: '8px',
        position: 'relative',
      },
    },
  },
  [MediaQueries.sm]: {
    borderRight: '0px',
  },
});
export const TabCtaCss = css({});
export const textHeaderCss = css({});

export const contentTabItemCss = css({
  opacity: 0,
  position: 'absolute',
  transition: 'opacity 300ms linear',
  width: '100%',
});
export const activeContentTab = css({ opacity: 1 });
